<template>
  <emat-block-dropdown
      v-if="device !== 'mobile'"
      :name="$t('ChargeTimes.advised_configuration')"
      :dropdown-title="$t('ChargeTimes.best_power') + carName "
      :inner-text="$t('ChargeTimes.charging_times')"
      icon="cogwheel"
      :class="{'disabled': !model}"
      :drop="!!model"
  >
    <template v-slot:left-title>Laadtijden</template>
    <template v-slot:left-content>
      <div class="table" v-if="model && model.charge_times">
        <div>
          <span></span>
          <span>{{ $t('global.label.power') }}</span>
          <span>{{ $t('ChargeTimes.charging_time_100') }}</span>
        </div>
        <div>
          <div v-for="(value, i) in chargeTimes" :key="i">
            <span><img :src="asset('/assets/images/icons/battery.svg')" alt=""></span>
            <span>{{ value.power }} kW</span>
            <span>
              {{ formatTime(value.time) }}
              <span class="duplicate" v-if="value.duplicate">*</span></span>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:right-title>{{ plug.name }} {{ $t('global.word.plug') }}</template>
    <template v-slot:right-content>
      <p class="text">{{ $t('ChargeTimes.plug_is_used', {plug: plug.name.toLowerCase()}) }}{{ carName }}</p>
      <img
          style="height: 90px; margin-top: 10px; filter: grayscale(1) contrast(250%);"
          v-if="plug"
          :src="plug.image_url"
          alt=""
      >
    </template>
  </emat-block-dropdown>
</template>

<script>
import {mapGetters} from 'vuex';

import BatterySvg from 'Components/../assets/icons/battery.svg?inline';
import PlugSvg from 'Components/../assets/icons/plug.svg?inline';

import EmatBlockDropdown from 'Components/Layout/BlockDropdown';
import helpers from '@/mixins/helpers';

export default {
  name: 'ChargeTimes',

  mixins: [helpers],

  components: {
    EmatBlockDropdown,
    BatterySvg,
    PlugSvg,
  },

  data() {
    return {
      hasDuplicates: false,
    };
  },

  computed: {
    ...mapGetters({
      device: 'getDevice',
      brand: 'build/getBrand',
      model: 'build/getModel',
    }),
    plug() {
      return this.$store.getters['build/methods/getPlugById'](this.model.configuration.plug_id);
    },
    carName() {
      let name = '';

      if (this.brand) name += this.brand.name + ' ';
      if (this.model) name += this.model.name;

      return name;
    },
    chargeTimes() {
      if (this.model === null) {
        return [];
      }

      const chargeTimes =
        Object.keys(this.model.charge_times)
          .map(key => {
            return {
              power: Number(key), time: this.model.charge_times[key],
            };
          })
          .filter(time => time.power === 2.3 || time.power === 7.4 || time.power === 11 || time.power === 22);

      chargeTimes.sort(function(a, b) {
        if (a.power < b.power) { return -1; }
        if (a.power > b.power) { return 1; }
        return 0;
      });

      let tempArray = [];
      chargeTimes.map(chargeTime => {
        if (tempArray.find(x => x === chargeTime.time)) {
          this.hasDuplicates = true;
          chargeTime.duplicate = true;
        } else {
          tempArray.push(chargeTime.time);
        }
      });
      tempArray = [];

      return chargeTimes;
    },
  },
  methods: {
    formatTime(val) {
      let hours = Math.floor(val / 60);
      let minutes = val % 60;
      return hours + 'u' + minutes + 'm';
    },
  },
};
</script>

<style scoped lang="scss">
.duplicate {
  color: #196CAE;
}

.table {
  border-radius: 0;
  box-shadow: unset;
}
</style>
